import React from 'react';
import DynamicTable from '../DynamicTable/DynamicTable';
import { TableWrapper } from '../StaticTable/StaticTable.style';

function GLAccountMaster(props) {
	const { data } = props;
	return (
		<TableWrapper>
			<DynamicTable data={data} />
		</TableWrapper>
	);
}

export default GLAccountMaster;
